import styled from 'styled-components';
import { Link } from '@components/link';

export const ListLink = styled(Link)`
  display: flex;
  padding: 8px 16px;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-start;
`;
